export default __webpack_public_path__ + "static/media/Dacia Maraini.f607355f.jpg";